var $ = require('../../../jCube');

exports.controlText = {

    build: function(_data) {
        return $.assign({}, _data, {
            tagName: 'input',
            container: {
                className: 'fb-text'
            },
            render: this.render
        });
    },

    render: function(dom) {

        if(this.validation.required === true){
            dom.required = true;
        }

        return dom;
    }
};
